import { KEY_REDUCER_SUPPORT } from "./constants";

const selectorSupport = (state) => state[KEY_REDUCER_SUPPORT];

export const selectorSupportMainGeneralQuestions = (s) => selectorSupport(s).mainGeneralQuestions;
export const selectorSupportFormSentStatus = (s) => selectorSupport(s).formSentStatus;

